export default __webpack_public_path__ + "static/media/how_cohortprojection_status.77b23d0d.png";